import React from 'react';
import styled from 'styled-components';


const Svg = styled.svg`
  width: 70%;
  fill: ${(props) => (props.color == 'azul' ? '#213c83' : '#fff')};
  transition: fill 0.3s ease-in-out;
  /* &:hover {
    fill: var(--verde);
  } */
`;

const AutoIcon = ({ color }) => (
  <Svg
    color={color}
    id="prefix__Capa_1"
    data-name="Capa 1"
    viewBox="0 0 145.07 69.06"
  >
    <path
      className="prefix__cls-1"
      d="M838.75 2265.34zm0 0zm-105.44-8.92a14.17 14.17 0 11-14.17 14.16 14.16 14.16 0 0114.17-14.16zm4.4 9.75a6.23 6.23 0 101.83 4.41 6.21 6.21 0 00-1.83-4.41zm79.56-9.75a14.17 14.17 0 11-14.16 14.16 14.16 14.16 0 0114.16-14.16zm4.41 9.75a6.23 6.23 0 101.83 4.41 6.25 6.25 0 00-1.83-4.41z"
      transform="translate(-702.14 -2215.69)"
    />
    <path
      className="prefix__cls-1"
      d="M805 2222.47l1 15.43c7.16 0 14.08.17 20.44.3 4.08.09 4.73-2.26 3.94-5.69a55.43 55.43 0 00-2.63-7.9 2.2 2.2 0 00-1.94-1.38c-7.07-.46-13.9-.72-20.58-.76zm-45.32 12.26a.77.77 0 01-.13.12c-2.23 1.81-.57 4.13 1.69 4 11.21-.69 23.59-.94 35.68-1l-1-15.32c-4.63.12-9.34.34-14.18.69-3.26.23-8.13 2.5-13.14 5.49a104.64 104.64 0 00-8.94 6zm-46.21 40.39h1.69a18.71 18.71 0 1136.29 0h47.67a18.7 18.7 0 1136.3 0h2.15c4.14 0 9.64.28 9.64-5.88v-4a6.56 6.56 0 00-2.35-5.13l-1.05-.92c0-14.41-1-25.18-8.42-38.07-1.44-2.49-3.44-4.23-6.32-4.43a331.34 331.34 0 00-47.79-.16c-10.23.73-28.62 14.16-35.51 21.13-7.15 1.21-37.6 5.22-39.48 13.2-.74 3.14-.6 6.8-1.32 10l-.13.06a4.45 4.45 0 00-2.7 4.15v2.93c0 6.42 6.36 7.16 11.33 7.16z"
      transform="translate(-702.14 -2215.69)"
    />
  </Svg>
);

export default AutoIcon;
